import React from 'react';
import './WorkInProgress.css';

const WorkInProgress = () => {
  return (
    <div className="wip-container">
      <div className="wip-screen">
        <div className="wip-text">WORK IN PROGRESS...</div>
        <div className="wip-subtext">Coming Soon</div>
      </div>
    </div>
  );
};

export default WorkInProgress;